'use client';

import { ReactNode } from 'react';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from '@services/apollo';
import { MantineProvider } from '@mantine/core';

import { theme } from 'ui-lib/mantine/theme';

import { GlobalModalProvider } from '../global-modals/app-router-providers';
import { AmplitudeExperimentsProvider } from '../feature-flag';
import { useOnIdTokenChangedObserver } from '../auth-helpers';
import { useCookieConsentListener } from '@hooks/use-cookie-consent-listener';

export function RootLayoutProvider({ children }: { children: ReactNode }) {
  useCookieConsentListener();
  useOnIdTokenChangedObserver();

  return (
    <ApolloProvider client={apolloClient}>
      <AmplitudeExperimentsProvider>
        <GlobalModalProvider>
          <MantineProvider theme={theme}>{children}</MantineProvider>
        </GlobalModalProvider>
      </AmplitudeExperimentsProvider>
    </ApolloProvider>
  );
}
